import { Button, Descriptions, Divider, Drawer, Empty, Flex, Tag } from "antd";
import React, { useState } from "react";
import CustomInput from "../../../../components/input/CustomInput";
import CustomSelect from "../../../../components/select/CustomSelect";
import CustomTextarea from "../../../../components/input/CustomTextarea";
import { useAuth } from "../../../../store/context/AuthContext";
import { useToast } from "../../../../components/toast/toast";
import { IconPlus } from "@tabler/icons-react";
import LotteryModal from "./LotteryModal";
import StatementModal from "./StatementModal";
import { formatCurrency, formatDateTime } from "../../../../utilities/utils";
import api from "../../../../api";
import TicketModal from "./TicketModal";

const renderStatusTag = (status) => {
  switch (status) {
    case "canceled" || "failed":
      return <Tag color="red">Цуцлагдсан</Tag>;
    case "paid":
      return <Tag color="blue">Төлсөн</Tag>;
    case "pending":
      return <Tag color="orange">Хүлээгдэж байна</Tag>;
    default:
      return <Tag color="default">{status}</Tag>;
  }
};

const renderSmsTag = (status) => {
  if (status === "sent") return <Tag color="green">Явсан</Tag>;
  if (status === "failed") return <Tag color="red">Амжилтгүй</Tag>;
  if (status === "pending") return <Tag color="orange">Хүлээгдэж байна</Tag>;
  return <Tag color="default">{status}</Tag>;
};

const SectionHeader = ({ title }) => (
  <Divider
    orientation="left"
    plain
    variant="dotted"
    style={{ borderColor: "#7cb305", marginBottom: "5px" }}
  >
    <h4>{title}</h4>
  </Divider>
);

export default function ComplainDrawer({ open, onClose }) {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    phone: "",
    title: "",
    description: "",
    user_request: "",
    type: "TICKET",
  });
  //#region Statement
  const [showModal, setShowModal] = useState(false);
  const [selectedStatement, setSelectedStatement] = useState(null);

  //#region Lottery
  const [visible, setVisible] = useState(false);
  const [selectedLottery, setSelectedLottery] = useState(null);

  //#region Ticket
  const [show, setShow] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const { reference } = useAuth();
  const toast = useToast();

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const clearHandler = () => {
    onClose();
    setFormData({
      phone: "",
      title: "",
      description: "",
      user_request: "",
      type: "TICKET",
    });
    setSelectedStatement(null);
    setSelectedLottery(null);
    setSelectedTicket(null);
  };

  // console.log("selectedStatement -->", selectedStatement);
  // console.log("selectedLottery -->", selectedLottery);
  // console.log("selectedTicket -->", selectedTicket);

  const submitHandler = async () => {
    // console.log(
    //   "submit",
    //   formData.phone,
    //   formData.title,
    //   formData.user_request,
    //   formData.description,
    //   selectedLottery,
    //   selectedStatement
    // );
    // const payload = {
    //   ...formData,
    //   lottery: selectedLottery || {},
    //   bankStatement: selectedStatement || {},
    //   ticket_prefix: selectedLottery?.ticket_prefix || "",
    // };
    const payload = {
      ...formData,

      ticket_prefix:
        selectedLottery?.ticket_prefix ||
        selectedTicket?.Lottery?.ticket_prefix ||
        "",
      ticket_id: selectedTicket?.id || "",
      invoice_id: selectedTicket?.invoice_id || "",
      lottery: selectedLottery || "",
      bankStatement: selectedStatement || {},
      // lottery_id: record.lottery_id || "",
      payment_id: selectedTicket?.Payments?.[0]?.id || "",
      lottery_numbers:
        selectedTicket?.LotteryNumbers?.map((e) => e.number) || "",
    };

    if (
      payload.title &&
      payload.description &&
      payload.user_request &&
      payload.phone
    ) {
      // console.log("payload --->", payload);
      setIsLoading(true);
      const res = await api.create_complaint(payload);
      // console.log("create complaint res --->", res);

      if (res.status === 201) {
        clearHandler();
        toast("Амжилттай үүслээ.", "success");
      } else {
        toast(res.data.message || "Алдаа гарлаа", "error");
      }
      setIsLoading(false);
    }
  };

  const payment = selectedTicket?.Payments?.[0];

  return (
    <>
      <Drawer
        title="Гомдол үүсгэх"
        placement="right"
        onClose={clearHandler}
        open={open}
        width={800}
        extra={
          <Button
            type="primary"
            style={{
              padding: "0px 30px",
              width: "fit-content",
            }}
            onClick={() => submitHandler()}
            disabled={
              !isLoading &&
              formData.phone &&
              formData.title &&
              formData.user_request &&
              formData.description &&
              selectedLottery &&
              selectedStatement
                ? false
                : true
            }
          >
            Хадгалах
          </Button>
        }
      >
        <Flex vertical gap={"10px"}>
          <Flex gap={10}>
            <CustomInput
              required={true}
              title={"Утасны дугаар"}
              value={formData.phone}
              maxLength={8}
              onChange={(e) => handleChange("phone", e.target.value)}
            />
            <CustomSelect
              required
              title={"Гарчиг"}
              options={reference
                .filter((e) => e.type === "complain_type")
                .map((e) => {
                  return {
                    label: e.name,
                    value: e.reference_key,
                  };
                })}
              value={formData.title}
              onChange={(e) => handleChange("title", e)}
              disabled={reference.length === 0}
            />
          </Flex>

          <Flex gap={10}>
            <CustomSelect
              required
              title={"Хэрэглэгчийн хүсэлт"}
              options={reference
                .filter((e) => e.type === "complaint_user_request")
                .map((e) => {
                  return {
                    label: e.name,
                    value: e.reference_key,
                  };
                })}
              value={formData.user_request}
              onChange={(e) => handleChange("user_request", e)}
              disabled={reference.length === 0}
            />
            <CustomTextarea
              required
              title={"Дэлгэрэнгүй"}
              value={formData.description}
              onChange={(e) => handleChange("description", e.target.value)}
              maxLength={200}
            />
          </Flex>
        </Flex>

        <Flex vertical gap={"4px"} style={{ marginTop: 20 }}>
          <SectionHeader title={"Банкны хуулга"} />
          <Button
            variant="dashed"
            color="primary"
            style={{
              padding: "0px 20px",
              width: "fit-content",
              alignSelf: "flex-end",
              marginBottom: 10,
            }}
            onClick={() => setShowModal(true)}
          >
            <IconPlus size={16} />
            Хуулга холбох
          </Button>
          {selectedStatement ? (
            <Descriptions
              bordered
              column={2}
              size="middle"
              labelStyle={{ fontWeight: 500, fontSize: 12 }}
            >
              <Descriptions.Item label="Дансны дугаар">
                {selectedStatement.account_number || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Холбоотой сугалаа">
                {selectedStatement.purchase_prefix || "-"}
              </Descriptions.Item>

              <Descriptions.Item label="Гүйлгээний дүн">
                <b>{formatCurrency(selectedStatement.amount)}</b>
              </Descriptions.Item>
              <Descriptions.Item label="Хэрэглэгчийн данс">
                {selectedStatement.raw_data?.relatedAccount || "-"}
              </Descriptions.Item>

              <Descriptions.Item label="Гүйлгээ хийсэн огноо">
                {selectedStatement.date_at
                  ? formatDateTime(selectedStatement.date_at)
                  : "-"}
              </Descriptions.Item>

              <Descriptions.Item label="Төлөв">
                <Tag color={"blue"}>
                  {selectedStatement.purchase_status || "-"}
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="Гүйлгээний утга" span={2}>
                {selectedStatement.description || "-"}
              </Descriptions.Item>
            </Descriptions>
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Хуулга холбоно уу."
            />
          )}
        </Flex>

        <Flex vertical gap={"10px"} style={{ marginTop: 20 }}>
          <SectionHeader title={"Сугалаа"} />
          <Button
            variant="dashed"
            color="primary"
            style={{
              padding: "0px 20px",
              width: "fit-content",
              alignSelf: "flex-end",
              marginBottom: 10,
            }}
            onClick={() => setVisible(true)}
          >
            <IconPlus size={16} />
            Сугалаа холбох
          </Button>
          {selectedLottery ? (
            <Descriptions bordered column={2} size="middle">
              <Descriptions.Item label="Код">
                {selectedLottery.ticket_prefix || "-"}
              </Descriptions.Item>

              <Descriptions.Item label="Үнэ">
                <b>{formatCurrency(selectedLottery.ticket_price)}</b>
              </Descriptions.Item>

              <Descriptions.Item label="Төлөв">
                {/* <Tag color={statusColor(selectedLottery.status)}>
                  {selectedLottery.status || "-"}
                  </Tag> */}
                {selectedLottery.status || "-"}
              </Descriptions.Item>

              <Descriptions.Item label="Ил харагдах байдал">
                {/* <Tag color={visibilityColor(selectedLottery.visibility)}>
                  {selectedLottery.visibility || "-"}
                  </Tag> */}
                {selectedLottery.visibility || "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Нэр">
                {selectedLottery.title || "-"}
              </Descriptions.Item>
            </Descriptions>
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Сугалаа холбоно уу."
            />
          )}
        </Flex>

        {/* --- --- --- TICKET ХОЛБОХ --- --- --- */}
        <Flex vertical gap={"4px"} style={{ marginTop: 20 }}>
          <SectionHeader title={"Тасалбар"} />
          <Button
            variant="dashed"
            color="primary"
            style={{
              padding: "0px 20px",
              width: "fit-content",
              alignSelf: "flex-end",
              marginBottom: 10,
            }}
            onClick={() => setShow(true)}
          >
            <IconPlus size={16} />
            Тасалбар холбох
          </Button>
          {selectedTicket ? (
            <Flex vertical gap={"20px"}>
              <Descriptions column={1} size="small" bordered>
                <Descriptions.Item label="Сугалааны нэр">
                  {selectedTicket.Lottery?.title || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Сугалааны код">
                  {selectedTicket.Lottery?.ticket_prefix || "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Утасны дугаар">
                  {selectedTicket.phone_number}
                </Descriptions.Item>
                <Descriptions.Item label="Төлөв">
                  {renderStatusTag(selectedTicket.status || "Тодорхойгүй")}
                </Descriptions.Item>
                {selectedTicket.canceled_comment && (
                  <Descriptions.Item
                    label={
                      selectedTicket?.status == "paid"
                        ? "Тайлбар"
                        : "Цуцалсан тайлбар"
                    }
                  >
                    {selectedTicket.canceled_comment}
                  </Descriptions.Item>
                )}
                <Descriptions.Item label="Үнэ">
                  {payment?.amount || "0"}₮
                </Descriptions.Item>
                <Descriptions.Item label="Төлбөрийн арга">
                  {payment?.method?.toUpperCase() || "-"}
                </Descriptions.Item>
                {selectedTicket?.BankInfo?.account && (
                  <Descriptions.Item label="Дансны дугаар">
                    {selectedTicket?.BankInfo?.account}
                  </Descriptions.Item>
                )}
                <Descriptions.Item label="Төлбөрийн төлөв">
                  {renderStatusTag(payment?.status || "Тодорхойгүй")}
                </Descriptions.Item>
                {payment?.method === "manual" && (
                  <Descriptions.Item label="Сугалаа өгсөн админ">
                    {payment?.meta?.assigned_by || "-"}
                  </Descriptions.Item>
                )}
                <Descriptions.Item label="Төлсөн огноо">
                  {payment?.paid_at
                    ? new Date(payment.paid_at).toLocaleString()
                    : "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Бүртгэгдсэн">
                  {new Date(selectedTicket.created_at).toLocaleString()}
                </Descriptions.Item>
              </Descriptions>

              <Descriptions column={1} size="small" bordered>
                <Descriptions.Item label="Сугалааны дугаар">
                  {selectedTicket?.LotteryNumbers?.length
                    ? selectedTicket.LotteryNumbers.map((e) => {
                        const short =
                          typeof e.number === "string"
                            ? e.number.replace(/^[^-]*-/, "")
                            : e.number;
                        return (
                          <Tag key={e.id} color="blue">
                            {/* {e.number} */}
                            {short}
                          </Tag>
                        );
                      })
                    : "-"}
                </Descriptions.Item>
                {/* <Descriptions.Item label="дугаар">
                          {selectedTicket?.match_code || "-"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Хэдэн орон таарсан">
                          {selectedTicket?.match_length || "-"}
                        </Descriptions.Item> */}
                {/* <Descriptions.Item label="Гарсан сугалааны дугаар">
                          {selectedTicket?.win_number || "-"}
                        </Descriptions.Item> */}
              </Descriptions>

              <Descriptions column={1} size="small" bordered>
                <Descriptions.Item label="Мессеж төлөв">
                  {renderSmsTag(
                    selectedTicket?.SmsInfo?.status || "Илгээгээгүй",
                  )}
                </Descriptions.Item>
                {selectedTicket?.SmsInfo?.message && (
                  <Descriptions.Item label="Мессеж">
                    {selectedTicket?.SmsInfo?.message || "-"}
                  </Descriptions.Item>
                )}
              </Descriptions>
            </Flex>
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Тасалбар холбоно уу."
            />
          )}
        </Flex>
      </Drawer>

      {/* ---------------- LOTTERY MODAL ---------------- */}
      <LotteryModal
        visible={visible}
        onClose={() => setVisible(false)}
        setSelectedLottery={setSelectedLottery}
      />

      {/* ---------------- STATEMENT MODAL ---------------- */}
      <StatementModal
        visible={showModal}
        onClose={() => setShowModal(false)}
        setSelectedStatement={setSelectedStatement}
      />

      {/* ---------------- TICKET MODAL ---------------- */}
      <TicketModal
        visible={show}
        onClose={() => setShow(false)}
        setSelectedTicket={setSelectedTicket}
      />
    </>
  );
}
